export default __webpack_public_path__ + "static/media/image.taloslogy.060081d0.png";